import { Quote } from './quoteTypes';
import http from '../../utilities/httpUtils';

export const getQuotes = async () => {
  const data = await http.get<Quote[]>('quotes', 'quoteService')();
  return data;
};

export const submitQuote = http.post<
  Quote,
  { amount: number; orderId: string }
>('submitQuote', 'quoteService');

export const cancelQuote = http.post<{ data: Quote }, { orderId: string }>(
  'cancelQuote',
  'quoteService'
);

export const acceptQuote = http.post<{ data: Quote }, { orderId: string }>(
  'acceptQuote',
  'quoteService'
);

export const counterQuote = http.post<
  { data: Quote },
  { amount: number; orderId: string }
>('counterQuote', 'quoteService');

export const declineQuote = http.post<{ data: Quote }, { orderId: string }>(
  'declineQuote',
  'quoteService'
);

export const discardQuote = http.post<{ data: Quote }, { orderId: string }>(
  'discardQuote',
  'quoteService'
);
